"use client";
import styles from "./index.module.css";
import { chatIconWhite } from "../../assets";
import ChatWindow from "../chat/ChatWindow";

import { useReachOutBox } from "../chat/useReachOutBox";
import { useEffect, useState } from "react";
import { useSocket } from "../chat/useSocket";

const ChatReachOutBox = ({ modal, organisation, accessPoint }) => {
  const {
    openChatWindow,
    chatInfo,
    chatPayload,
    loggedInUser,
    openChat,
    closeChat,
    markCommentsAsRead,
    activateGuestMode,
    chatGuestMode,
    chatBoxFetchError,
    clearPresetMessage,
    handleBoxRetry,
    showSenderName,
  } = useReachOutBox(organisation, accessPoint);

  const { socket } = useSocket();

  const [hasNewMessage, setHasNewMessage] = useState(false);

  useEffect(() => {
    const { sectionId, sectionName } = chatInfo;
    const { userId } = chatPayload;

    if (socket && sectionId) {
      const channel = `${sectionName}:${sectionId}`;

      const handler = (res) => {
        const { action, data } = res || {};
        if (!data) return;

        if (action === "new_comment" && userId !== data.userId) {
          setHasNewMessage(true);
          return;
        }
      };

      socket.on(channel, handler);

      return () => {
        socket.off(channel, handler);
      };
    }
  }, [socket, chatInfo]);

  return (
    <>
      {/* Floating button */}
      {!modal && (
        <div
          className={`${styles.ovalButton} ${styles.floatingChat}`}
          onClick={openChat}
        >
          Chat now {chatIconWhite}
          {hasNewMessage && chatInfo.unreadMessageCount > 0 && (
            <span className={styles.floatingChatNotification}>
              {chatInfo.unreadMessageCount}
            </span>
          )}
        </div>
      )}

      {/* Window */}
      {openChatWindow && !modal && (
        <ChatWindow
          loggedInUser={loggedInUser}
          isChatOpen={openChatWindow}
          closeChat={closeChat}
          chatPayload={chatPayload}
          chatInfo={chatInfo}
          markCommentsAsRead={markCommentsAsRead}
          activateGuestMode={activateGuestMode}
          chatGuestMode={chatGuestMode}
          chatBoxFetchError={chatBoxFetchError}
          clearPresetMessage={clearPresetMessage}
          handleBoxRetry={handleBoxRetry}
          showSenderName={showSenderName}
        />
      )}
    </>
  );
};

export default ChatReachOutBox;
